export default __webpack_public_path__ + "static/filedback-b04f00918a7352293fd3c5d1a9234349.png";